<template>
  <div
    v-if="rating"
    class="c-player__age-rating o-typography__headline3"
  >
    {{ rating }}
  </div>
</template>
<script>
  import { state } from '@/shared/components/player/store';

  const AgeRating = {
    ADULT: 16,
    TEEN: 12,
    KID: 7,
  };

  export default {
    name: 'UiPlayerAgeRating',
    data() {
      return {
        info: this.$services.resolve('info'),
      };
    },
    computed: {
      rating() {
        if (!this.info.ageRatingOverlay) {
          return;
        }

        const rating = state.product.rating || state.product.season?.serial?.rating;

        if (rating >= AgeRating.ADULT) {
          return '18+';
        }

        if (rating >= AgeRating.TEEN) {
          return '14+';
        }

        if (rating >= AgeRating.KID) {
          return '7+';
        }
      },
    },
  };
</script>
